import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentComponent } from "./shared/components/layout/content/content.component";
import { HomeComponent } from './components/home/home.component';
import { AuthGuard } from './shared/guard/auth.guard';
import { LoginComponent } from './components/Login/login/login.component';

const routes: Routes = [
  {
    path: '',
    // redirectTo: 'cab/add-cab-booking',
    // pathMatch: 'content'
    component: HomeComponent
  },
  {
    path: '',
    component: ContentComponent,
    children: [
      {
        path: 'cab',
        loadChildren: () => import('./components/apps/cab/cab.module').then(m => m.CabModule)
      },
      {
        path: 'guest-house',
        loadChildren: () => import('./components/apps/guest-house/guest-house.module').then(m => m.GuestHouseModule)
      },
      {
        path: 'master',
        loadChildren: () => import('./components/apps/master/master.module').then(m => m.MasterModule)
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./components/dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'reports',
        loadChildren: () => import('./components/apps/reports/report.module').then(m => m.ReportModule)
      },
      {
        path: 'permission-master',
        loadChildren: () => import('./components/apps/permission-master/permission-master.module').then(m => m.PermissionMasterModule)
      },
      {
        path: 'approval-matrix',
        loadChildren: () => import('./components/apps/ApprovalMatrix/approval-matrix.module').then(m => m.ApprovalMatrixModule)
      },
      // {
      //   path: 'login',
      //   loadChildren: () => import("../app/components/Login/login.module").then(m => m.LoginModule)
      // },

    ]
  },

  {
    path: 'login',
    component: LoginComponent,
    children: [
      {
        path: 'login-user',
        loadChildren: () => import('./components/Login/login.module').then(m => m.LoginModule)
      },
    ]

  },

  // {
  //   path: 'login',
  //   component: LoginComponent,
  // },
  //  {
  //   path: 'login',
  //   component: ContentComponent, 
  //   children: [
  //     {
  //       path: 'login-user',
  //       loadChildren: () => import("../app/components/Login/login.module").then(m => m.LoginModule)
  //     },
  //   ]
  // },

  {
    path: '**',
    redirectTo: ''
  },

  // { path : '' , redirectTo: '/login-user', pathMatch: 'full' },
];

@NgModule({
  imports: [[RouterModule.forRoot(routes, {
    useHash: true,
    anchorScrolling: 'enabled',
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
